"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = exports.MTableToolbar = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _classnames = _interopRequireDefault(require("classnames"));
var _filefy = require("filefy");
var _propTypes = _interopRequireWildcard(require("prop-types"));
require("jspdf-autotable");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

const jsPDF = typeof window !== "undefined" ? require("jspdf").jsPDF : null;
/* eslint-enable no-unused-vars */

class MTableToolbar extends React.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "onSearchChange", searchText => {
      this.props.dataManager.changeSearchText(searchText);
      this.setState({
        searchText
      }, this.props.onSearchChanged(searchText));
    });
    (0, _defineProperty2.default)(this, "getTableData", async () => {
      const columns = this.props.columns.filter(columnDef => (!columnDef.hidden || columnDef.export === true) && columnDef.export !== false && columnDef.field).sort((a, b) => a.tableData.columnOrder > b.tableData.columnOrder ? 1 : -1);
      const data = (this.props.exportAllData ? await Promise.resolve(this.getAllData()) : this.props.renderData).map(rowData => columns.map(columnDef => this.props.getFieldValue(rowData, columnDef)));
      return [columns, data];
    });
    (0, _defineProperty2.default)(this, "getAllData", () => {
      if (typeof this.props.remoteDataGetter === "function") return this.props.remoteDataGetter();else return this.props.data;
    });
    (0, _defineProperty2.default)(this, "defaultExportCsv", async () => {
      const [columns, data] = await this.getTableData();
      let fileName = this.props.title || "data";
      if (this.props.exportFileName) {
        fileName = typeof this.props.exportFileName === "function" ? this.props.exportFileName() : this.props.exportFileName;
      }
      const builder = new _filefy.CsvBuilder(fileName + ".csv");
      builder.setDelimeter(this.props.exportDelimiter).setColumns(columns.map(columnDef => columnDef.title)).addRows(data).exportFile();
    });
    (0, _defineProperty2.default)(this, "defaultExportPdf", async () => {
      if (jsPDF !== null) {
        const [columns, data] = await this.getTableData();
        let content = {
          startY: 50,
          head: [columns.map(columnDef => columnDef.title)],
          body: data
        };
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);
        doc.text(this.props.exportFileName || this.props.title, 40, 40);
        doc.autoTable(content);
        doc.save((this.props.exportFileName || this.props.title || "data") + ".pdf");
      }
    });
    (0, _defineProperty2.default)(this, "exportCsv", async () => {
      if (this.props.exportCsv) {
        this.props.exportCsv(this.props.columns, this.props.data);
      } else {
        await this.defaultExportCsv();
      }
      this.setState({
        exportButtonAnchorEl: null
      });
    });
    (0, _defineProperty2.default)(this, "exportPdf", async () => {
      if (this.props.exportPdf) {
        this.props.exportPdf(this.props.columns, this.props.data);
      } else {
        await this.defaultExportPdf();
      }
      this.setState({
        exportButtonAnchorEl: null
      });
    });
    this.state = {
      columnsButtonAnchorEl: null,
      exportButtonAnchorEl: null,
      searchText: props.searchText
    };
  }
  renderSearch() {
    const localization = (0, _objectSpread2.default)({}, MTableToolbar.defaultProps.localization, this.props.localization);
    if (this.props.search) {
      return /*#__PURE__*/React.createElement(_TextField.default, {
        autoFocus: this.props.searchAutoFocus,
        className: this.props.searchFieldAlignment === "left" && this.props.showTitle === false ? null : this.props.classes.searchField,
        value: this.state.searchText,
        onChange: event => this.onSearchChange(event.target.value),
        placeholder: localization.searchPlaceholder,
        variant: this.props.searchFieldVariant,
        InputProps: {
          startAdornment: /*#__PURE__*/React.createElement(_InputAdornment.default, {
            position: "start"
          }, /*#__PURE__*/React.createElement(_Tooltip.default, {
            title: localization.searchTooltip
          }, /*#__PURE__*/React.createElement(this.props.icons.Search, {
            fontSize: "small"
          }))),
          endAdornment: /*#__PURE__*/React.createElement(_InputAdornment.default, {
            position: "end"
          }, /*#__PURE__*/React.createElement(_IconButton.default, {
            disabled: !this.state.searchText,
            onClick: () => this.onSearchChange(""),
            "aria-label": localization.clearSearchAriaLabel
          }, /*#__PURE__*/React.createElement(this.props.icons.ResetSearch, {
            fontSize: "small",
            "aria-label": "clear"
          }))),
          style: this.props.searchFieldStyle,
          inputProps: {
            "aria-label": localization.searchAriaLabel
          }
        }
      });
    } else {
      return null;
    }
  }
  renderDefaultActions() {
    const localization = (0, _objectSpread2.default)({}, MTableToolbar.defaultProps.localization, this.props.localization);
    const {
      classes
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, this.props.columnsButton && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Tooltip.default, {
      title: localization.showColumnsTitle
    }, /*#__PURE__*/React.createElement(_IconButton.default, {
      color: "inherit",
      onClick: event => this.setState({
        columnsButtonAnchorEl: event.currentTarget
      }),
      "aria-label": localization.showColumnsAriaLabel
    }, /*#__PURE__*/React.createElement(this.props.icons.ViewColumn, null))), /*#__PURE__*/React.createElement(_Menu.default, {
      anchorEl: this.state.columnsButtonAnchorEl,
      open: Boolean(this.state.columnsButtonAnchorEl),
      onClose: () => this.setState({
        columnsButtonAnchorEl: null
      })
    }, /*#__PURE__*/React.createElement(_MenuItem.default, {
      key: "text",
      disabled: true,
      style: {
        opacity: 1,
        fontWeight: 600,
        fontSize: 12
      }
    }, localization.addRemoveColumns), this.props.columns.map(col => {
      if (!col.hidden || col.hiddenByColumnsButton) {
        return /*#__PURE__*/React.createElement("li", {
          key: col.tableData.id
        }, /*#__PURE__*/React.createElement(_MenuItem.default, {
          className: classes.formControlLabel,
          component: "label",
          htmlFor: "column-toggle-".concat(col.tableData.id),
          disabled: col.removable === false
        }, /*#__PURE__*/React.createElement(_Checkbox.default, {
          checked: !col.hidden,
          id: "column-toggle-".concat(col.tableData.id),
          onChange: () => this.props.onColumnsChanged(col, !col.hidden)
        }), /*#__PURE__*/React.createElement("span", null, col.title)));
      }
      return null;
    }))), this.props.exportButton && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Tooltip.default, {
      title: localization.exportTitle
    }, /*#__PURE__*/React.createElement(_IconButton.default, {
      color: "inherit",
      onClick: event => this.setState({
        exportButtonAnchorEl: event.currentTarget
      }),
      "aria-label": localization.exportAriaLabel
    }, /*#__PURE__*/React.createElement(this.props.icons.Export, null))), /*#__PURE__*/React.createElement(_Menu.default, {
      anchorEl: this.state.exportButtonAnchorEl,
      open: Boolean(this.state.exportButtonAnchorEl),
      onClose: () => this.setState({
        exportButtonAnchorEl: null
      })
    }, (this.props.exportButton === true || this.props.exportButton.csv) && /*#__PURE__*/React.createElement(_MenuItem.default, {
      key: "export-csv",
      onClick: this.exportCsv
    }, localization.exportCSVName), (this.props.exportButton === true || this.props.exportButton.pdf) && /*#__PURE__*/React.createElement(_MenuItem.default, {
      key: "export-pdf",
      onClick: this.exportPdf
    }, localization.exportPDFName))), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(this.props.components.Actions, {
      actions: this.props.actions && this.props.actions.filter(a => a.position === "toolbar"),
      components: this.props.components
    })));
  }
  renderSelectedActions() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(this.props.components.Actions, {
      actions: this.props.actions.filter(a => a.position === "toolbarOnSelect"),
      data: this.props.selectedRows,
      components: this.props.components
    }));
  }
  renderActions() {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.actions
    }, /*#__PURE__*/React.createElement("div", null, this.props.selectedRows && this.props.selectedRows.length > 0 ? this.renderSelectedActions() : this.renderDefaultActions()));
  }
  renderToolbarTitle(title) {
    const {
      classes
    } = this.props;
    const toolBarTitle = typeof title === "string" ? /*#__PURE__*/React.createElement(_Typography.default, {
      variant: "h6",
      style: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, title) : title;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.title
    }, toolBarTitle);
  }
  render() {
    const {
      classes
    } = this.props;
    const localization = (0, _objectSpread2.default)({}, MTableToolbar.defaultProps.localization, this.props.localization);
    const title = this.props.showTextRowsSelected && this.props.selectedRows && this.props.selectedRows.length > 0 ? typeof localization.nRowsSelected === "function" ? localization.nRowsSelected(this.props.selectedRows.length) : localization.nRowsSelected.replace("{0}", this.props.selectedRows.length) : this.props.showTitle ? this.props.title : null;
    return /*#__PURE__*/React.createElement(_Toolbar.default, {
      className: (0, _classnames.default)(classes.root, {
        [classes.highlight]: this.props.showTextRowsSelected && this.props.selectedRows && this.props.selectedRows.length > 0
      })
    }, title && this.renderToolbarTitle(title), this.props.searchFieldAlignment === "left" && this.renderSearch(), this.props.toolbarButtonAlignment === "left" && this.renderActions(), /*#__PURE__*/React.createElement("div", {
      className: classes.spacer
    }), this.props.searchFieldAlignment === "right" && this.renderSearch(), this.props.toolbarButtonAlignment === "right" && this.renderActions());
  }
}
exports.MTableToolbar = MTableToolbar;
MTableToolbar.defaultProps = {
  actions: [],
  columns: [],
  columnsButton: false,
  localization: {
    addRemoveColumns: "Add or remove columns",
    nRowsSelected: "{0} row(s) selected",
    showColumnsTitle: "Show Columns",
    showColumnsAriaLabel: "Show Columns",
    exportTitle: "Export",
    exportAriaLabel: "Export",
    exportCSVName: "Export as CSV",
    exportPDFName: "Export as PDF",
    searchTooltip: "Search",
    searchPlaceholder: "Search",
    searchAriaLabel: "Search",
    clearSearchAriaLabel: "Clear Search"
  },
  search: true,
  showTitle: true,
  searchText: "",
  showTextRowsSelected: true,
  toolbarButtonAlignment: "right",
  searchAutoFocus: false,
  searchFieldAlignment: "right",
  searchFieldVariant: "standard",
  selectedRows: [],
  title: "No Title!"
};
MTableToolbar.propTypes = {
  actions: _propTypes.default.array,
  columns: _propTypes.default.array,
  columnsButton: _propTypes.default.bool,
  components: _propTypes.default.object.isRequired,
  getFieldValue: _propTypes.default.func.isRequired,
  localization: _propTypes.default.object.isRequired,
  onColumnsChanged: _propTypes.default.func.isRequired,
  dataManager: _propTypes.default.object.isRequired,
  searchText: _propTypes.default.string,
  onSearchChanged: _propTypes.default.func.isRequired,
  search: _propTypes.default.bool.isRequired,
  searchFieldStyle: _propTypes.default.object,
  searchFieldVariant: _propTypes.default.string,
  selectedRows: _propTypes.default.array,
  title: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  showTitle: _propTypes.default.bool.isRequired,
  showTextRowsSelected: _propTypes.default.bool.isRequired,
  toolbarButtonAlignment: _propTypes.default.string.isRequired,
  searchFieldAlignment: _propTypes.default.string.isRequired,
  remoteDataGetter: _propTypes.default.func,
  renderData: _propTypes.default.array,
  data: _propTypes.default.array,
  exportAllData: _propTypes.default.bool,
  exportButton: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    csv: _propTypes.default.bool,
    pdf: _propTypes.default.bool
  })]),
  exportDelimiter: _propTypes.default.string,
  exportFileName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  exportCsv: _propTypes.default.func,
  exportPdf: _propTypes.default.func,
  classes: _propTypes.default.object,
  searchAutoFocus: _propTypes.default.bool
};
const styles = theme => ({
  root: {
    paddingRight: theme.spacing(1)
  },
  highlight: theme.palette.type === "light" ? {
    color: theme.palette.secondary.main,
    backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.85)
  } : {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.dark
  },
  spacer: {
    flex: "1 1 10%"
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    overflow: "hidden"
  },
  searchField: {
    minWidth: 150,
    paddingLeft: theme.spacing(2)
  },
  formControlLabel: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  }
});
exports.styles = styles;
var _default = exports.default = (0, _withStyles.default)(styles)(MTableToolbar);